$(document).on('ready', function () {
    let numberInput = $('.js_number'),
        baggageModal = $('#js_baggage-modal'),
        baggageModalOpen = $('.js_baggage-modal-open'),
        baggageModalReset = $('.js_baggage-modal-reset'),
        baggageModalSubmit = $('.js_baggage-modal-submit'),
        baggageInput = $('#specify_baggage'),
        baggageDynamicContainer = $('.js_baggage-dynamic-container'),
        baggageDynamicInput = $('.js_baggage-dynamic__input');

    numberInput.on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
    })

    baggageModalOpen.on('click', function () {
        baggageModal.addClass('is-show');
    })

    baggageModalReset.on('click', function () {
        setCountBaggage(0);
        baggageModal.removeClass('is-show');

        baggageDynamicContainer.children().remove();
        baggageDynamicInput.val(baggageDynamicContainer.children().length).trigger('change');
        baggageModal.find('.js_countable-input').each(function () {
            let self = $(this);

            self.val(self.data('min')).trigger('change').siblings('[data-func="inc"]').prop('disabled', false).siblings('button').prop('disabled', true);
        });
    })

    baggageModalSubmit.on('click', function () {
        let count = 0;
        baggageModal.find('.js_countable-input').each(function () {
            let self = $(this);
            count += Number(self.val());
        });
        count += Number(baggageDynamicContainer.children().length);
        setCountBaggage(count);
        baggageModal.removeClass('is-show');
    })

    $('.js_baggage-dynamic-inc').on('click', function () {
        let index = baggageDynamicContainer.children().length + 1,
            itemsContainer = $('.iframe-baggage-modal__items'),
            name = $(this).data('name');

            baggageDynamicContainer.append(getDynamicElem(index, name));

        baggageDynamicInput.val(index).trigger('change');

        itemsContainer.scrollTop(itemsContainer[0].scrollHeight);
        baggageDynamicContainer.scrollLeft(baggageDynamicContainer[0].scrollWidth);
    })

    $('.js_baggage-type-count').on('change', function () {
        let cost = 0;
        $('.js_baggage-type-count').each(function () {
            cost += ($(this).data('cost') * $(this).val());

            cost ? baggageModalSubmit.attr('data-additional-cost', cost) : baggageModalSubmit.removeAttr('data-additional-cost');
        })
    })

    $(document)
        .on('click', '.js_baggage-dynamic-dec', function () {
            $(this).closest('.js_baggage-dynamic-item').remove();
            baggageDynamicContainer.children().each(function (index, elem) {
                $(elem).find('input').each(function (i, input) {
                    $(input).attr('name', $(input).attr('name').replace(/\d+/, index + 1));
                })
            })
            baggageDynamicInput.val(baggageDynamicContainer.children().length).trigger('change');
        })
        .on('click', '.js_baggage-dynamic-remove', function () {
            $(this).siblings('input').val('');
        })

    function setCountBaggage(count) {
        if ($('input[name=bags]').length) {
            let input = $('input[name=bags]');

            input.val(count);

            count ? input.siblings('[data-func=dec]').prop('disabled', false) : input.siblings('[data-func=dec]').prop('disabled', true);
        } else {
            baggageModalOpen.attr('data-count', count);
        }
        baggageInput.val(count ? 1 : 0);
    }

    function getDynamicElem(index, name = "Нестандарт") {
        return '<div class="iframe-baggage-modal-subitem js_baggage-dynamic-item">' +
            '<div class="iframe-baggage-modal-subitem__heading">' +
            '    <span class="iframe-baggage-modal-subitem__name">Багаж "' + name + '"</span>' +
            '    <button type="button" class="iframe-baggage-modal-subitem__remove js_baggage-dynamic-dec">' +
            '       <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '    </button>' +
            '</div>' +
            '<div class="iframe-baggage-modal-subitem__sizes">' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][length]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Длина см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][width]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Ширина см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][height]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Высота см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '</div>' +
            '<div class="iframe-baggage-modal-subitem__description">' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input" type="text" name="baggage[' + index + '][description]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Описание</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '</div>' +
            '</div>';
    }
})